import React from "react";
import './Footer.css'
// import FleetorderLogo from '../assets/fleetorder-logo.png'
import FleetorderLogo from '../assets/fleetorder-white.png'
import SocialIcon1 from '../assets/footer-social-icon-1.png'
import SocialIcon2 from '../assets/footer-social-icon-2.png'

function Footer() {
    return (
        <div className="footer-main-container">
            <div className="footer-sub-container">
                <div className="footer-first-section">
                    <div className="footer-title-section">
                        <img src={FleetorderLogo} alt="footer-fleetorder-logo" className="fleetorder-footer-logo" />
                        {/* <h1 className="footer-title">Fleetorder</h1> */}
                    </div>
                    <p className="footer-description-main">Revolutionizing restaurant operations with cutting-edge technology.</p>
                    <a href="https://www.sassymonks.com/" className="footer-product-main-anchor" target="_blank"><p className="footer-product-name">(Product of SassyMonks Private Limited)</p></a>
                    
                </div>

                <div className="footer-first-section">
                    <div className="footer-title-section">
                        {/* <img src={FooterFleetorderLogo} alt="footer-fleetorder-logo" className="footer-fleetorder-logo" /> */}
                        <h1 className="footer-title">Legal</h1>
                    </div>
                    <a href="/terms-and-conditions" className="footer-description-anchor"><p className="footer-description">Terms & Conditions</p></a>
                    <a href="/privacy-and-policy" className="footer-description-anchor"><p className="footer-description">Privacy Policy</p></a>
                    <a href="/cancellation-and-refund-policy" className="footer-description-anchor"><p className="footer-description">Cancellation & Refund</p></a>
                </div>

                <div className="footer-first-section">
                    <div className="footer-title-section">
                        {/* <img src={FooterFleetorderLogo} alt="footer-fleetorder-logo" className="footer-fleetorder-logo" /> */}
                        <h1 className="footer-title">Where we are now</h1>
                    </div>
                    <p className="footer-description">Hyderabad | Vijaywada | Kurnool | Nellore | Kakinada | Guntur | Kadapa | Tenali | Vizag | Mancherial | Rishikesh | Aurangabad</p>
                     
                </div>

                <div className="footer-first-section">
                    <div className="footer-title-section">
                        {/* <img src={FooterFleetorderLogo} alt="footer-fleetorder-logo" className="footer-fleetorder-logo" /> */}
                        <h1 className="footer-title">Follow Us</h1>
                    </div>
                    
                    <div className="social-media-icons">
                    <a href="https://www.facebook.com/fleetorder.in/" target="_blank"><img src={SocialIcon1} alt="footer-fleetorder-logo" className="footer-fleetorder-logo social-icon" /></a>
                    
                    <a href="https://www.instagram.com/fleetorder.in?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                    <img src={SocialIcon2} alt="footer-fleetorder-logo" className="footer-fleetorder-logo social-icon" />
                     </a>
                     </div>
                </div>

                <div className="footer-first-section">
                    <div className="footer-title-section">
                        
                        <h1 className="footer-title">Contact</h1>
                    </div>
                    <p className="footer-description">+91 7386616587</p>
                    <p className="footer-description">sales@fleetorder.in</p>
                </div>
            </div>
        </div>
    )
}

export default Footer